import './NavigationSection.scss';
import * as React from 'react';
import { Link } from 'gatsby';
import classnames from 'classnames';
import NavigationSubsection from './NavigationSubSection';
type Props = {
  path: string;
  page: {
    name: string;
    slug: string;
    path: string;
    pages: Array<{
      name: string;
      slug: string;
      path: string;
    }>;
  };
  currentPageHeadings: Array<{
    value: string;
    depth: number;
  }>;
  currentHeading: string | undefined | null;
};
type State = {
  expanded: boolean;
  hovered: boolean;
};
/**
 * Renders one top level item in the navigation for a specific product and
 * version. Can expands to show sub pages, and defaults to expanded if the
 * current page is it or one of its sub pages.
 */
export default class NavigationSection extends React.Component<Props, State> {
  isCurrent = () => this.props.path === this.props.page.path;
  isSubPageCurrent = () =>
    this.props.path.match(`^${this.props.page.path}`) != null;
  state = {
    expanded: this.isCurrent() || this.isSubPageCurrent(),
    hovered: false,
  };
  toggleExpanded = () => {
    this.setState({
      expanded: !this.state.expanded,
    });
  };
  handleSectionClicked = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (this.isCurrent()) {
      event.preventDefault();
      this.toggleExpanded();
      return false;
    }
  };
  handleMouseEnter = () => {
    this.setState({
      hovered: true,
    });
  };
  handleMouseLeave = () => {
    this.setState({
      hovered: false,
    });
  };
  render() {
    const { path, page, currentHeading } = this.props;
    const currentPageHeadings = this.props.currentPageHeadings.filter(
      (heading) => heading.depth < 3,
    );
    const { expanded, hovered } = this.state;
    const isCurrent = this.isCurrent();
    return (
      <li className="NavigationSection">
        <div
          className={classnames('NavigationSection-row', {
            'is-current': isCurrent,
            'is-hovered': hovered,
          })}
        >
          <Link
            to={page.path}
            onClick={this.handleSectionClicked}
            onMouseEnter={this.handleMouseEnter}
            onMouseLeave={this.handleMouseLeave}
            className="NavigationSection-row-name"
          >
            {page.name}
          </Link>

          <button
            className="NavigationSection-button"
            onClick={this.toggleExpanded}
          >
            {expanded ? '↑' : '↓'}
          </button>
        </div>

        {expanded && (
          <ul className="NavigationSection-subsections">
            {page.pages.map((subPage, index) => (
              <NavigationSubsection
                key={index}
                path={path}
                page={subPage}
                currentPageHeadings={currentPageHeadings}
                currentHeading={currentHeading}
              />
            ))}
          </ul>
        )}
      </li>
    );
  }
}
